import { DISABLED_TABS_FOR_QRB, MERCHANT_PRODUCTS } from 'OpsCenter/app.constants';

export default function MerchantController(
  $scope,
  $stateParams,
  $location,
  $timeout,
  merchantService,
  switchToBcService,
  MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED,
  MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED,
  switchToBAService,
  switchToRMAService,
  switchToHostService,
  switchToQRBService,
  employeesService,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.merchant = $stateParams.merchant;
  vm.externalPartnerSources = null;
  vm.switchToBCEnabled = false;
  vm.switchToBAEnabled = false;
  vm.switchToRMAEnabled = false;
  vm.switchToHostEnabled = false;
  vm.switchToQRBEnabled = false;
  vm.isLoading = true;
  vm.isQRBMerchant = false;
  vm.hasEmployees = false;

  vm.tabs = {
    services: false,
    searchTags: false,
    images: false,
    configuration: false,
    areas: false,
    employees: false,
    settings: false,
    combinations: false,
    times: false,
    retention: false,
    menu: false,
    tools: false,
  };

  vm.selectTab = selectTab;
  vm.deselectTab = deselectTab;
  vm.switchToBC = switchToBC;
  vm.switchToBA = switchToBA;
  vm.switchToRMA = switchToRMA;
  vm.switchToHost = switchToHost;
  vm.switchToQRB = switchToQRB;

  init();
  $scope.$on('merchant.configuration.updated', function(event, data) {
    if (data && data.merchant) {
      vm.switchToBCEnabled = isSwitchToEnabled(data.merchant);
      vm.switchToBAEnabled = isSwitchToBAEnabled(data.merchant);
      vm.switchToHostEnabled = isSwitchToHostEnabled(data.merchant);
      vm.switchToQRBEnabled = isSwitchToQRBEnabled(data.merchant);
      vm.merchant = data.merchant;
      vm.isQRBMerchant = data.merchant.productIds.includes(MERCHANT_PRODUCTS.QRB);
    }
  });

  $scope.$on('merchant.tab.merchant-tools.selected', function(event, data) {
    vm.merchant = data.merchant;
    vm.integrationPartnerSources = data.externalPartnerSources;
    vm.externalPartnerSubSources = data.externalPartnerSubSources,
    vm.currentIntegrationMigrationStatus = data.currentIntegrationMigrationStatus;
    $scope.$apply();
  });

  function init() {
    vm.isLoading = true;
    vm.currentIntegrationMigrationStatus = null;
    getEmployees(vm.merchantId)
      .then(() => getMerchant(vm.merchantId))
      .then(() => getExternalPartnerSource())
      .finally(() => {
        vm.isLoading = false;
        if ($stateParams.tab) {
          vm.selectTab($stateParams.tab);
        } else {
          vm.selectTab('configuration');
        }
      });
  }

  function getEmployees(id) {
    return employeesService.getEmployees(id).then(function(res) {
      if (res && res.data) {
        vm.hasEmployees = res.data.employees.length > 0;
      }
    });
  }

  function getMerchant(id) {
    return merchantService.getMerchantById(id)
      .then(function(res) {
        if (res && res.data) {
          vm.merchant = res.data;
          vm.switchToBCEnabled = isSwitchToEnabled(vm.merchant);
          vm.switchToBAEnabled = isSwitchToBAEnabled(vm.merchant);
          vm.switchToRMAEnabled = isSwitchToRMAEnabled(vm.merchant);
          vm.switchToHostEnabled = isSwitchToHostEnabled(vm.merchant);
          vm.switchToQRBEnabled = isSwitchToQRBEnabled(vm.merchant);
          vm.isQRBMerchant = vm.merchant.productIds.includes(MERCHANT_PRODUCTS.QRB);
        }
      });
  }

  function getExternalPartnerSource() {
    return merchantService.getExternalPartnerSource(vm.merchantId)
      .then(function(res) {
        if (res && res.data && res.data.sources) {
          vm.externalPartnerSources = res.data.sources;
          vm.externalPartnerSubSources = res.data.subSources || [];
          vm.currentIntegrationMigrationStatus = vm.externalPartnerSources.length > 0 ?
            vm.externalPartnerSources[0].migrationStatus : null;
        } else {
          vm.externalPartnerSources = [];
          vm.externalPartnerSubSources = [];
          vm.currentIntegrationMigrationStatus = null;
        }
      })
      .catch(function(error) {
        vm.externalPartnerSources = [];
        vm.externalPartnerSubSources = [];
        vm.currentIntegrationMigrationStatus = null;
      });
  }
  function switchToBC() {
    switchToBcService.switchTo(vm.merchant);
  }

  function switchToBA() {
    switchToBAService.switchToBA(vm.merchant);
  }

  function switchToRMA() {
    switchToRMAService.switchToRMA(vm.merchant);
  }

  function switchToHost() {
    switchToHostService.switchToHost(vm.merchant);
  }

  function switchToQRB() {
    vm.isLoading = true;
    switchToQRBService.switchToQRB(vm.merchant).finally(function() {
      vm.isLoading = false;
    });
  }

  function selectTab(tab) {
    if (!vm.merchant) {
      return;
    }

    if (vm.isQRBMerchant && DISABLED_TABS_FOR_QRB.includes(tab)) {
      $location.search('tab', 'configuration');
      return;
    }
    $location.search('tab', tab);
    vm.tabs[tab] = true;
    $timeout(function() {
      $scope.$broadcast('merchant.tab.' + tab + '.selected', {
        merchant: vm.merchant,
        externalPartnerSources: vm.externalPartnerSources,
        externalPartnerSubSources: vm.externalPartnerSubSources,
        currentIntegrationMigrationStatus: vm.currentIntegrationMigrationStatus
      });
    }, 100);
  }

  function deselectTab(tab) {
    vm.tabs[tab] = false;
  }

  function isSwitchToEnabled(merchant) {
    var switchToEnabled = false;

    angular.forEach(MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED, function(productId) {
      if (merchant.productIds.indexOf(productId) > -1) {
        switchToEnabled = true;
      }
    });
    if (merchant.productIds.indexOf(MERCHANT_PRODUCTS.EXTERNAL_PARTNER) > -1 &&
      vm.hasEmployees) {
      switchToEnabled = true;
    }
    return switchToEnabled;
  }

  function isSwitchToQRBEnabled(merchant) {
    return merchant.productIds.includes(MERCHANT_PRODUCTS.QRB) ||
      (merchant.productIds.includes(MERCHANT_PRODUCTS.EXTERNAL_PARTNER) && !vm.hasEmployees);
  }

  function isSwitchToBAEnabled(merchant) {
    const isAndroidDevice = navigator.userAgent.toLowerCase().includes('android');
    const isValidBAProduct = MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED.some(productId => merchant.productIds.includes(productId));
    return isValidBAProduct && isAndroidDevice;
  }

  function isSwitchToRMAEnabled(merchant) {
    const isIphoneDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isValidRMAProduct = MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED.some(productId => merchant.productIds.includes(productId));
    return isValidRMAProduct && isIphoneDevice;
  }

  function isSwitchToHostEnabled(merchant) {
    const isTablet = /Tablet|iPad/.test(navigator.userAgent) || navigator.userAgent.toLowerCase().includes('android');
    const isValidHostProduct = MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED.some(productId => merchant.productIds.includes(productId));
    return isValidHostProduct && isTablet;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchant.controller.js